import { Component, Renderer2 } from "@angular/core";
import { Router, UrlSerializer } from "@angular/router";
import { QuizService } from '../../../Service/Quizservice';
import json from "../../../assets/survey.json";
import {Directive, Input, Output, EventEmitter} from '@angular/core';
import { SurveyModel } from 'survey-angular';
import * as Survey from "survey-angular";
import CryptoJS from 'crypto-js';
import { HttpClient } from "@angular/common/http";
declare var gtag: Function;
@Component({
  selector: "StudentQuiz-page",
  templateUrl: "./StudentQuiz.page.html",
  styleUrls: ["./Student.css"],
})
@Directive({
  selector: '[ngInit]'
})
export class StudentQuizPage{
  gtmId;
  json;
  Studentroute;
  @Input() username;
  studentid;
  issubmitted;

  @Output('ngInit') initEvent: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
    const script = this.renderer.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id='+this.gtmId;
    // Add an onload event to ensure the script is loaded before using gtag
    script.onload = () => {
      this.initGtag();
    };
  
    // Append the script to the head section of the document
    this.renderer.appendChild(document.head, script);
    this.username=sessionStorage.getItem('studname') ;
    this.studentid=sessionStorage.getItem("sid");
    this.issubmitted=sessionStorage.getItem("issubmitted");

    document.getElementById("btnGroupDrop1").innerText=this.username;
  }
  constructor(private QuizService: QuizService,private router: Router,private renderer:Renderer2,private http:HttpClient) {    
    this.json = JSON.parse(sessionStorage.getItem("editjson"));
    this.getconfigkey().subscribe(data=>{
      
      //this.url=data['url'];
      this.gtmId=data['gtmId'];
      
     
    })
    setTimeout(()=>{
       
  
      if(sessionStorage.getItem("studname")==undefined){
        this.router.navigate(['/'+this.router.url.split('/')[1]])
      }
      sessionStorage.setItem("routeurl",router.url)  
    },100);    
  }
  public getconfigkey():any{   
         
    return this.http.get("assets/env.json");            
    }
  private initGtag() {
    // Add the Google Tag Manager script
    const gTagScript = this.renderer.createElement('script');
    gTagScript.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
    `;
  
    // Append the GTM script to the head section of the document
    this.renderer.appendChild(document.head, gTagScript);
  
    let users;
    let roles;
  
    //if ( this.username) {
      users =  this.username;
      roles = "Student";
   // } 
  
    console.log("User initgtg:", users);
    console.log("Role:", roles);
  
    // Now you can safely use the gtag function
    gtag('event', 'user_details', { 'UserName': users, 'UserType': roles });
  
    // Rest of your ngOnInit() code...
  }
  sendData(result) {
    //TODO update with your own behavior
    const surveyModel = new Survey.Model(this.json);    
  }
  
  logout(){
    sessionStorage.clear();
  }
  
}